/**
 * @enum RegistrationRoute
 * @description It includes Routes url Related to Registration Portal
 */
export enum RegistrationRoute {
  Redirect = "/redirect",
  Home = "/",
  Form = "/form",
  InitiateReg = "/form/initiate",
  Payment = "/form/payment",
  Confirmation = "/form/confirmation",
  InvoicePayerConfirmation = "/form/confirmation-ip",
  CouponCode = "/code",

  Cookies = "/cookies"
}
